import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';

import CoinsSwapIcon from 'app/components/Icons/CoinsSwapIcon';
import BankIcon from 'app/components/Icons/BankIcon';
import ManatIcon from 'app/components/Icons/ManatIcon';
import GlobusIcon from 'app/components/Icons/GlobusIcon';
import SwitchIcon from 'app/components/Icons/SwitchIcon';
import CoinsStackedIconSelect from 'app/components/Icons/CoinsStackedIconSelect';
import WalletIconSelect from '../../components/Icons/WalletIconSelect';
import SaleIcon from 'app/components/Icons/SaleIcon';
import InfoIcon from 'app/components/Icons/InfoIcon';
import RepeatIcon from 'app/components/Icons/RepeatIcon';
import PrintIcon from 'app/components/Icons/PrintIcon';
import DownloadAdocIcon from 'app/components/Icons/DownloadAdocIcon';
import BinIcon from 'app/components/Icons/BinIcon';

import { getTheme } from 'app/components/ThemeProvider/theme';

const useSalaryPage = () => {
  const theme = getTheme('light');
  const [searchParams] = useSearchParams();
  const pageType = searchParams.get('type');
  const pageSubpage = searchParams.get('subpage');
  const [value, setValue] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeAnchor, setActiveAnchor] = useState('');

  const [saveTemplate, setSaveTemplate] = useState(false);
  const [successModal, setSuccesModal] = useState(false);

  const navigate = useNavigate();

  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const { control, register } = useForm();

  const tabletScreen = useMediaQuery(theme.breakpoints.down(768));
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [firstFocused, setFirstFocused] = useState(false);
  const [secondFocused, setSecondFocused] = useState(false);

  const onFocusNext = () => {
    setFirstFocused(true);
  };
  const onFocusEnd = () => {
    setSecondFocused(true);
  };
  const handlerBlur = () => {
    setFirstFocused(false);
    setSecondFocused(false);
  };

  const handleMenuClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (anchorEl !== null) {
      setActiveAnchor(anchorEl.getAttribute('aria-controls'));
    }
  }, [anchorEl]);

  const filterBtns = [
    { id: 2, title: 'Yeni ödəniş', route: 'new-payments' },
    { id: 1, title: 'İşçi siyahisi', route: 'employee-table' },
    { id: 3, title: 'Ödənişlərin tarixçəsi', route: 'payments-history' },
  ];

  const options = [
    { value: 'Öz hesablarım arasında', label: 'Öz hesablarım arasında', icon: <CoinsSwapIcon /> },
    { value: 'Bankdaxili', label: 'Bankdaxili', icon: <BankIcon /> },
    { value: 'Ölkədaxili', label: 'Ölkədaxili', icon: <ManatIcon /> },
    { value: 'Ölkəxarici', label: 'Ölkəxarici', icon: <GlobusIcon /> },
    { value: 'Konvertasiya', label: 'Konvertasiya', icon: <SwitchIcon sx={{ width: '20px', height: '20px' }} /> },
    { value: 'Ədv ödənişi', label: 'Ədv ödənişi', icon: <CoinsStackedIconSelect /> },
    { value: 'Büdcə ödənişi', label: 'Büdcə ödənişi', icon: <WalletIconSelect /> },
    { value: 'Kredit ödənişi', label: 'Kredit ödənişi', icon: <SaleIcon /> },
  ];

  const onChange = () => {
    setValue(value);
  };

  const handleChangePageType = (id: string) => {
    navigate(`${lang}/salary?type=${id}`);
  };

  const handleNewPaymentPage = () => {
    navigate(`${lang}/salary?type=new-payments`);
  };

  const tableHeader = [
    {
      id: '1',
      name: 'İşçinin A.S.A',
    },
    {
      id: '2',
      name: 'Hesab nömrəsi / IBAN',
    },
    {
      id: '3',
      name: 'Məbləğ',
    },
  ];

  const details = [
    {
      title: 'Detallara bax',
      icon: <InfoIcon />,
    },
    {
      title: 'Təkrarla',
      icon: <RepeatIcon />,
    },
    {
      title: 'Çap et',
      icon: <PrintIcon />,
    },
    {
      title: 'Adoc faylı köçür',
      icon: <DownloadAdocIcon />,
    },
    {
      title: 'Sil',
      icon: <BinIcon sx={{ width: '18px', height: '18px' }} color={'warning'} />,
    },
  ];

  return {
    filterBtns,
    options,
    value,
    onChange,
    tableHeader,
    details,
    anchorEl,
    activeAnchor,
    setActiveAnchor,
    handleMenuClick,
    handleClose,
    saveTemplate,
    successModal,
    pageType,
    setSaveTemplate,
    setSuccesModal,
    register,
    control,
    tabletScreen,
    smallScreen,
    firstFocused,
    secondFocused,
    pageSubpage,
    handleChangePageType,
    handleNewPaymentPage,
    handlerBlur,
    onFocusNext,
    onFocusEnd,
  };
};

export default useSalaryPage;
